import Http from "./http-service";
import { showNotification } from "../UtilityFunctions/notification";
import { getLocalizedMessage } from "../UtilityFunctions/utils";
import { setLoading } from "../globalContext/globalLoader/globalLoaderAction";
import { getNotificationsList as getNotificationsListAction, setNotificationsLoading } from "../globalContext/notifications/notificationsActions";
import { PRIVATE_API_ROUTES } from "../constants";

class NotificationService {
  static async getAllNotifications({ dispatch, params, intl }) {
    dispatch(setNotificationsLoading(true))
    return Http.get(PRIVATE_API_ROUTES.GET_NOTIFICATIONS_LIST, params) // API Route for Notifications
      .then(({ data }) => {
        dispatch(setNotificationsLoading(false));
        dispatch(getNotificationsListAction(data?.data));
      })
      .catch(() => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        dispatch(setNotificationsLoading(false))
      });
  }

  static async markNotificationRead({ intl, loaderDispatch }) {
    loaderDispatch(setLoading(true));
    return Http.get(PRIVATE_API_ROUTES.MARK_NOTIFICATION_READ)
      .then((res) => {
        loaderDispatch(setLoading(false));
        return Promise.resolve(res);
      })
      .catch((err) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }
}

export default NotificationService;
